import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('offerflow_token');
    const savedUser = localStorage.getItem('offerflow_user');
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      API.get('/auth/me').then(res => {
        setUser(res.data);
        localStorage.setItem('offerflow_user', JSON.stringify(res.data));
      }).catch(() => {
        localStorage.removeItem('offerflow_token');
        localStorage.removeItem('offerflow_user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    localStorage.setItem('offerflow_token', res.data.token);
    localStorage.setItem('offerflow_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (name, email, password) => {
    const res = await API.post('/auth/register', { name, email, password });
    localStorage.setItem('offerflow_token', res.data.token);
    localStorage.setItem('offerflow_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const setUserFromGoogle = useCallback((token, userData) => {
    localStorage.setItem('offerflow_token', token);
    localStorage.setItem('offerflow_user', JSON.stringify(userData));
    setUser(userData);
  }, []);

  const logout = () => {
    localStorage.removeItem('offerflow_token');
    localStorage.removeItem('offerflow_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, setUserFromGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
